import { useState,memo } from 'react'
import { useAuth } from '../contexts/AuthContext'
import { Eye, EyeOff, LogIn, X } from 'lucide-react'
import LoadingSpinner from '../components/LoadingSpinner'
import Logo from './logo/ketaqwaan-logo.png'

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',  
    password: ''
  })
  const [showPassword, setShowPassword] = useState(false)
  const [loading, setLoading] = useState(false)
  const [showAdminInfo, setShowAdminInfo] = useState(false)
  
  const { login } = useAuth()

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    
    const result = await login(formData.email, formData.password)
    
    if (!result.success) {
      setLoading(false)
    }
  }

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }))
  }


  const handleAdminLinkClick = (e) => {
    e.preventDefault();
    setShowAdminInfo(!showAdminInfo); 
  }
  
  const clientUrl= import.meta.env.VITE_CLIENT_URL

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <div className="mx-auto h-20 w-20 rounded-lg flex items-center justify-center">
            {/* <span className="text-white font-bold text-xl">K</span> */}
            <img src={Logo} alt="logo SIE 1 Ketaqwaan MAN 1 JEMBER" />
          </div>
          <h2 className="mt-6 text-center lg:text-3xl text-xl font-extrabold text-primary-700">
            Admin Panel
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Ketaqwaan MAN 1 Jember
          </p>
        </div>
        
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div className="space-y-4 lg:px-0 px-10">
            <div>
              <label htmlFor="email" className="block lg:text-sm text-xs font-medium text-gray-700">
                Email Address
              </label>
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                value={formData.email}
                onChange={handleChange}
                className="mt-1 appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-primary-500 focus:border-primary-500 focus:z-10 sm:text-sm text-xs"
                placeholder="Enter your email"
              />
            </div>
            
            <div>
              <label htmlFor="password" className="block lg:text-sm text-xs font-medium text-gray-700">
                Password
              </label>
              <div className="mt-1 relative">
                <input
                  id="password"
                  name="password"
                  type={showPassword ? 'text' : 'password'}
                  autoComplete="current-password"
                  required
                  value={formData.password}
                  onChange={handleChange}
                  className="appearance-none relative block w-full px-3 py-2 pr-10 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-primary-500 focus:border-primary-500 focus:z-10 sm:text-sm text-xs"
                  placeholder="Enter your password"
                />
                <button
                  type="button"
                  className="absolute inset-y-0 right-0 pr-3 flex items-center"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <EyeOff className="h-4 w-4 text-gray-400" />
                  ) : (
                    <Eye className="h-4 w-4 text-gray-400" />
                  )}
                </button>
              </div>
            </div>
          </div>

          <div className="lg:px-0 px-10">
            <button
              type="submit"
              disabled={loading}
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent lg:text-sm text-xs font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? (
                <LoadingSpinner size="sm" />
              ) : (
                <>
                  <LogIn className="w-4 h-4 mr-2" />
                  Sign In
                </>
              )}
            </button>
            {/* signup */}
            <button
            type='button'
            onClick={() => window.location.href = '/signup'}
            className="mt-2 group relative w-full flex justify-center py-2 px-4 border border-teal lg:text-sm text-xs font-medium rounded-md text-white bg-slate-700 hover:bg-slate-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Sign Up Penulis 

            </button>
          </div>

          <div className="text-center">
            <div>
            <p className="text-xs text-gray-500 mb-2">
                Lupa password?{' '}
                {/* <<< 2. Link yang memicu alert */}
                <a href="#" onClick={handleAdminLinkClick} className='font-medium text-primary-700 hover:text-primary-600'>
                  hubungi admin
                </a>
            </p>
            </div>
            {showAdminInfo && (
              <div className="relative bg-teal-100 border-l-4 border-teal-500 text-teal-800 p-4 rounded-lg text-left">
                <p className="lg:text-base text-sm font-bold">Informasi Kontak Admin</p>
                <p className="lg:text-sm text-xs">Silakan hubungi admin jika lupa password. Terima Kasih</p>
                <p className="lg:text-sm text-xs mt-1">WA: <strong>[Hisyam]</strong></p>
                <button 
                  onClick={() => setShowAdminInfo(false)} 
                  className="absolute top-1 right-1 p-1 text-teal-600 hover:text-teal-800"
                >
                  <X size={16} />
                </button>
              </div>
            )}

            <a className='text-xs text-gray-500' href={clientUrl}>Pergi ke <span className='text-primary-700'>SIE 1 KETAQWAAN MAN 1 JEMBER</span></a>
          </div>
        </form>
      </div>
    </div>
  )
}

export default memo(Login)